import { GoogleOAuthProvider, GoogleLogin as GoogleLoginButton } from "@react-oauth/google";
import LangService from "../../../services/LangService";

import styles from "../Auth.module.scss";

const clientId = `${process.env.REACT_APP_GOOGLE_CLIENT_ID}.apps.googleusercontent.com`;

export const GoogleLogin = ({
    onGoogleSuccess,
    onGoogleFailure
}) => {
    const authMap = LangService.map.pages.Auth;

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <div className={styles.googleButton}>
                <GoogleLoginButton
                    onSuccess={(res) => onGoogleSuccess({ ...res, tokenId: res.credential })}
                    onError={onGoogleFailure}
                    theme="filled_black"
                    text="signin_with"
                    locale={LangService.lang === "RU" ? "ru" : "en"}
                />
            </div>
            <span className="sr-only">{authMap.googleButtonText}</span>
        </GoogleOAuthProvider>
    )
}